function About() {
  return (
    <>
      <div style={{ marginTop: '15rem', width: '100%', height: '10px' }} className="about-scroll"></div>

      <div className="container about">
        <div className="row">
          <div className="col-md-6 text-center">
            {/* Updated the image path using process.env.PUBLIC_URL */}
            <img 
              alt="about" 
              src={process.env.PUBLIC_URL + "/img/About.png"} 
              className="img-fluid" 
            />
          </div>
          <div className="col-md-6">
            <h2 className="main-title about-h2">ABOUT</h2>
            <p className="main-p">
            FreeLance Developers, we are a passionate team dedicated to creating high-quality, custom web solutions. With a focus on innovation, functionality, and user experience, we collaborate closely with our clients to bring their vision to life. From sleek websites to complex web applications, we ensure every project is tailored to meet your unique business needs.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default About;
